'use strict';
require('./CompanyTimestampsService.js');

CompanyCustomerTimestampsHistoryCtrl.$inject = [
  '$scope',
  '$stateParams',
  'CompanyTimestampsService',
  'service'];
function CompanyCustomerTimestampsHistoryCtrl(
  $scope,
  $stateParams,
  CompanyTimestampsService,
  service) {

    $scope.timestamps = service.timestamps;
    $scope.more = false;
    $scope.page = 0;
    
    if($scope.timestamps.length > 20) {
      $scope.more = true;
    }

    $scope.getTimestampHistory = function(page){
      CompanyTimestampsService.query({
        companyId: $stateParams.companyId,
        objectId: service.id,
        limit: 21,
        offset: page * 20
      }, function(resp){
        $scope.timestamps = resp;
        if($scope.timestamps.length > 20) {
          $scope.more = true;
          if(page !== 0){
            $scope.timestamps.pop();
          }
        }else{
          $scope.more = false;
        }
        $scope.page = page;
      });
    };
}

module.exports = CompanyCustomerTimestampsHistoryCtrl;

angular.module('dokiv')
  .controller('CompanyCustomerTimestampsHistoryCtrl', CompanyCustomerTimestampsHistoryCtrl);



//////////////////
// WEBPACK FOOTER
// ./scripts/company/timestamps/CompanyCustomerTimestampsHistoryCtrl.js
// module id = 422
// module chunks = 0